export default __webpack_public_path__ + "static/media/boite11.0a18afd6.jpg";